import { render, staticRenderFns } from "./px-navigation-tab.vue?vue&type=template&id=24bb6ae3&scoped=true&"
import script from "./px-navigation-tab.vue?vue&type=script&lang=ts&"
export * from "./px-navigation-tab.vue?vue&type=script&lang=ts&"
import style0 from "./px-navigation-tab.vue?vue&type=style&index=0&id=24bb6ae3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb6ae3",
  null
  
)

export default component.exports